<template>
  <div class="px-2 h-full">
    <DataTable
      v-model:filters="filters"
      :value="queryStore.exploreData?.columns"
      filter-display="menu"
      :global-filter-fields="['name', 'Origins', 'Description']"
      paginator
      size="small"
      :rows="5"
      :rows-per-page-options="[5, 10, 20, 50]"
      table-style="min-width: 50rem"
      scrollable
      scroll-height="flex"
    >
      <template #header>
        <Dialog
          v-model:visible="dialogVisible"
          modal
          class="m-4 max-w-2xl max-h-[80vh] overflow-y-auto"
        >
          <div>{{ dialogContent }}</div>
        </Dialog>
        <div
          v-if="!queryStore.exploreData?.name"
          class="flex items-center min-h-14"
        >
          <h3>Explore Nodes</h3>
        </div>
        <div
          v-else
          class="header w-full flex flex-row gap-3 justify-start align-center items-center py-2"
        >
          <div
            class="header w-full flex flex-row flex-wrap gap-3 justify-start align-center items-center py-2"
          >
            <h3>{{ queryStore.exploreData?.name }}</h3>
            <h4 class="text-muted-color">
              {{ queryStore.exploreData?.row_count?.toLocaleString() }} rows
            </h4>
            <h4 class="hidden md:block text-muted-color">
              {{ queryStore.exploreData?.description.slice(0, 20) }}...
            </h4>
            <InformationTooltip
              class="w-6 h-6 self-center min-w-5 min-h-5 ml-1 text-muted-color"
              :tooltip="queryStore.exploreData?.description"
              @click.stop="
                dialogContent = queryStore.exploreData?.description;
                dialogVisible = true;
              "
            />
          </div>
          <IconField class="ml-auto">
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText
              v-model="filters['global'].value"
              class="w-48"
              placeholder="Keyword Search"
            />
          </IconField>
        </div>
      </template>
      <template #empty>
        <div v-if="filters['global'].value">
          No data. Clear filters to see more results
        </div>
        <div v-else>Select node to see information</div>
      </template>
      <Column field="name" header="Name"></Column>
      <Column field="Key" header="Keys">
        <template #body="{ data, field }">
          {{ data[field]?.join(", ") }}
        </template>
      </Column>
      <Column field="Origins" header="Origin">
        <template #body="{ data, field }">
          {{ data[field]?.join(", ") }}
        </template>
      </Column>
      <Column field="DataType" header="DataType"></Column>
      <Column field="Description" header="Description"></Column>
      <Column field="Values" header="Values">
        <template #body="{ data, field }">
          <div v-for="(d, index) in data[field]" :key="index">{{ d }}</div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import IconField from "primevue/iconfield";
import Dialog from "primevue/dialog";
import { ref } from "vue";
import { FilterMatchMode } from "@primevue/core/api";
import InformationTooltip from "@/components/InformationTooltip.vue";
import { useQueryStore } from "@/stores/queryStore.js";

const queryStore = useQueryStore();

const filters = ref({
  global: { value: null, matchMode: ref(FilterMatchMode.CONTAINS) },
});

const dialogContent = ref("");
const dialogVisible = ref(false);
</script>

<style scoped></style>
